import axios from "axios";

const getToken = () => {
  let token = sessionStorage.getItem('token') ? sessionStorage.getItem('token') : localStorage.getItem('token');
  let refresh = sessionStorage.getItem('refresh') ? sessionStorage.getItem('refresh') : localStorage.getItem('refresh');
  return { token, refresh }
}

const axiosClientFSR = axios.create({
  baseURL: `${process.env.REACT_APP_FSR}`,
  headers: {
    "content-type": "application/json",
    "token": getToken().token,
  },
});

axiosClientFSR.interceptors.request.use(async (config) => {
  try {
    // const authToken = (await getTokenCsc()).token;
    // config.headers.token = authToken;
    return config;
  } catch (error) {
    console.error('Failed to set token in request headers:', error);
    return Promise.reject(error);
  }
});
axiosClientFSR.interceptors.response.use(
  (response) => {
    if (response && response.data) {
      return response.data;
    }
    return response;
  },
  (error) => {
    if (getToken().token && error?.response?.status === 401) {
      // // console.log(getToken().refresh, getToken().token);
      async function refreshToken() {
        try {
          const res = await axios.post(
            `${process.env.REACT_APP_API_URL}authenticator/refreshToken/`,
            {
              refresh: getToken().refresh,
            },
            {
              headers: {
                "Content-Type": "application/json",
                // "X-Forwarded-For": `${sessionStorage.getItem("ip")}`,
              },
            }
          );
          sessionStorage.setItem("token", res.data.access);
          localStorage.setItem("token", res.data.access);
          // // console.log('done set token');
          // sessionStorage.setItem("token", res.data.access);
          window.location.reload()
        } catch (error) {
          if (error?.response?.status === 401) {
            // // console.log(getToken());
            window.location.replace('/admin/login')
          }
        }
      }
      refreshToken();
    }
    throw error;
  }
);
export default axiosClientFSR;
